import { defineMessages } from 'react-intl';

export default defineMessages({
  courtManagerJudgementValidate: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.validate',
  },
  courtManagerJudgementRefuse: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.refuse',
  },
  managerDecision: {
    id: 'manager.decision.title',
  },
  supportDocument: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.support_document',
  },
  courtManagerJudgementAddStatus: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.status',
  },
  courtManagerJudgementAddDecision: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.title',
  },
  rejectedDecision: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.rejected',
  },
  validatedDecision: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.validated',
  },
  rejectionReason: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.rejection.reason',
  },
  updatedBy: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.updated_by',
  },
  validate: {
    id: 'legal_proceeding_page.validation_buttons.validate',
  },
  updateMessage: {
    id: 'judgement_add_update.success',
  },
  lawyerFirmReferenceUpdateMessage: {
    id: 'legal_proceeding_page.check_firm_reference_info',
  },
  lawyerFirmReferenceEditMessage: {
    id: 'legal_proceeding_page.check_update_firm_reference_info',
  },
  lawyerFirmReferenceFeeNoteMessage: {
    id: 'legal_proceeding_page.check_fee_note_firm_reference_info',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  editButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.updateButton',
  },
  generateFeeNote: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.generateFeeNote',
  },
  creatorTitle: {
    id: 'legal_proceeding_page.update_firm_reference_lawyer_name',
  },
  creatorTitleMultiple: {
    id: 'legal_proceeding_page.judgement_add_multiple_created_by',
  },
  courtManagerJudgementUpdate: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.update',
  },
});
